import * as types from './mutations-types'

export default {
  [types.setPaymentMethodConfigs] (state, paymentMethodConfigs) {
    state.paymentMethodConfigs = paymentMethodConfigs
  },
  [types.clearPaymentMethods] (state) {
    state.paymentMethods = {}
  },
  [types.setProcessors] (state, processors) {
    state.processors = processors
  },
  [types.setPaymentMethod] (state, paymentMethod) {
    state.paymentMethod = paymentMethod
  },
  [types.setPaymentMethods] (state, paymentMethods) {
    state.paymentMethods = paymentMethods
  },
  [types.setFilterPaymentMethod] (state, obj) {
    state.filterPaymentMethods[obj.key] = obj.value
  },
  [types.billetMethod] (state, obj) {
    state.billetMethod = obj
  },
  [types.reprocessBilletMethod] (state, obj) {
    state.reprocessBilletMethod = obj
  },
  [types.cardMethod] (state, obj) {
    state.cardMethod = obj
  },
  [types.transferMethod] (state, obj) {
    state.transferMethod = obj
  },
  [types.balanceMethod] (state, obj) {
    state.balanceMethod = obj
  },
  [types.reprocessCardMethod] (state, obj) {
    state.reprocessCardMethod = obj
  },
  [types.setTypes] (state, types) {
    state.types = types
  },
  [types.yapayToken] (state, token) {
    state.yapayToken = token
  },
  [types.setCustomFields] (state, customFields) {
    state.customFields = customFields
  },
  [types.setCustomFieldsValues] (state, customFieldsValues) {
    state.customFieldsValues = customFieldsValues
  },
  [types.setGatewayFieldsValues] (state, gatewayFieldsValues) {
    state.gatewayFieldsValues = gatewayFieldsValues
  },
  [types.clearFilterPaymentMethod] (state, key) {
    delete state.filterPaymentMethods[key]
  },
  [types.clearFilterPaymentMethods] (state) {
    state.filterPaymentMethods = {}
  },
  [types.setAddressFound] (state, address) {
    state.addressFound = address
  },
  [types.setBillingSettings] (state, billingSetting) {
    state.billingSettings = billingSetting
  },
  [types.setWebhookSettings] (state, webhookSetting) {
    state.webhookSettings = webhookSetting
  },
  [types.setNfeSettings] (state, nfeSetting) {
    state.nfeSettings = nfeSetting
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/vuex/mutations.js